import { vuexfireMutations, firebaseAction } from 'vuexfire'
import { db } from '@/config/firebaseConfig'
import { clean } from '@/utils/clean.js'

const state = {
  orderList: [],
  currentOrder: ''
}

const mutations = {
  ...vuexfireMutations,
  'SET_CURRENT_ORDER' (state, currentOrder) {
    if (currentOrder) {
      state.currentOrder = currentOrder
    }
  }
}

const actions = {
  bindOrders: firebaseAction(({ bindFirebaseRef, getters }) => {
    bindFirebaseRef('orderList', db().ref(`/orders/${getters.shopId}/${getters.currentUser.uid}/`))
  }),
  addPaymentDetails ({ getters }, paymentDetails) {
    return db().ref(`/payments/${getters.shopId}/`).push(paymentDetails)
  },
  updatePaymentMethod ({ getters }, orderDetails) {
    return db().ref(`/orders/${getters.shopId}/${orderDetails.customer.uid}/${orderDetails['.key']}/details/paymentMethod`).set(orderDetails.details.paymentMethod)
  },
  saveToTransaction ({ commit, getters }, { uid, cartItemList, orderDetails }) {
    let newTransactionKey = db().ref(`/orders/${getters.shopId}`).push().key
    var newTransaction = {}
    clean(orderDetails)
    let status = [
      { status: 'confirming' },
      { status: 'preparing' },
      { status: 'ready' },
      { status: 'delivering' },
      { status: 'completed' }
    ]
    status[0].startTime = db.ServerValue.TIMESTAMP
    commit('SET_CURRENT_ORDER', newTransactionKey)
    newTransaction = {
      items: cartItemList,
      details: orderDetails,
      currentStatus: 'confirming',
      customer: getters.currentUser,
      paid: false,
      status: status
    }
    if (orderDetails.paymentMethod === 'Credit Card') {
      newTransaction.paid = 'pending'
    }
    return db().ref(`/orders/${getters.shopId}/${uid}/${newTransactionKey}`).set(newTransaction)
  }
}
const getters = {
  currentOrder: (state) => {
    return state.currentOrder
  },
  orders: (state) => state.orderList
}

export default {
  state,
  mutations,
  actions,
  getters
}
